import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import { shippingTransportationMethods } from "../../helpers/utils/transportationMethods";

const TransportationMethodOptions = ({
  value,
  onChange,
  size = "small",
  disabled
}) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    onChange={(_, newValue) => newValue && onChange(newValue)}
    aria-label="Transportation Method"
    size={size}
    disabled={disabled}
  >
    {shippingTransportationMethods.map((option) => (
      <ToggleButton
        key={option.value}
        value={option.value}
        aria-label={option.label}
      >
        {option.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default TransportationMethodOptions;
